import { render, staticRenderFns } from "./license-overview.vue?vue&type=template&id=ccf4aa32&scoped=true"
import script from "./license-overview.vue?vue&type=script&lang=js"
export * from "./license-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4aa32",
  null
  
)

export default component.exports